<div class="scrolled" *ngIf="!loader">

    <div class="divider layout-padd-2 title-filter-date" ngClass.xs="layout-padd-5" #pageTitle>
        <span class="mat-headline" ngClass.xs="mat-title">{{'merchantComponent.merchants'|translate}}</span>
    </div>

    <table mat-table [dataSource]="dataSource" class="full-w clicked" ngClass.xs="fix-w-table" matSort>

        <ng-container matColumnDef="denomination">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>{{'merchantComponent.merchant'|translate}}</th>
            <td mat-cell *matCellDef="let merchant">
                {{merchant.denomination | uppercase}}</td>
        </ng-container>

        <ng-container matColumnDef="order" stickyEnd>
            <th mat-header-cell *matHeaderCellDef> </th>
            <td mat-cell *matCellDef="let merchant">

                <div fxLayoutAlign="end center">

                    <mat-icon fxHide fxShow.xs class="great-ico clicked" matTooltip="{{'merchantComponent.boutiacc'|translate}}" matTooltipPosition="below" (click)="goOrder(merchant.url_encode, merchant.id_webshop)" angulartics2On="click" angularticsAction="goOrder" angularticsCategory="clientMerchants">shopping_cart</mat-icon>

                    <button fxHide.xs mat-stroked-button (click)="goOrder(merchant.url_encode, merchant.id_webshop)" angulartics2On="click" angularticsAction="goOrder" angularticsCategory="clientMerchants">
            <span>{{'merchantComponent.boutiacc'|translate}}&nbsp;&nbsp;</span>
            <mat-icon class="great-ico clicked" matTooltip="{{'merchantComponent.boutiacc'|translate}}" matTooltipPosition="below"
              (click)="goOrder(merchant.url_encode, merchant.id_webshop)" angulartics2On="click" angularticsAction="goOrder"
              angularticsCategory="clientMerchants">shopping_cart</mat-icon>
          </button>

                </div>

            </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>

    <mat-paginator [pageSizeOptions]="[10, 20, 50, 100]" showFirstLastButtons></mat-paginator>

</div>

<app-popup-loader [flagLoading]="loader" [size]="60" [statusMessage]="'merchantComponent.getmerchant'|translate">
</app-popup-loader>